<template>
  <boxwrap class="matches--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
          class="toolbar-nav"
          :title="$route.params.status || 'all'"
          v-model="selectedList"
          @input="change"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="ongoing"
            name="ongoing"
          >
            <span>ongoing</span>
          </select-option>

          <select-option
            value="waiting"
            name="waiting"
          >
            <span>waiting</span>
          </select-option>

          <select-option
            value="done"
            name="done"
          >
            <span>done</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
        >
        </search>

        <button
          class="btn--create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
        >
          <i class="ico--invisible"></i>
        </button>

        <button
          class="btn--restore"
        >
          <i class="ico--visible"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}"> <!--  -->
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td class="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                v-if="checkCol('no', tblSetting)"
                @click.native="sort('id')"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                name="game"
                :sort="true"
                @click.native="sort('game')"
                v-if="checkCol('game', tblSetting)"
              >
                game
              </tbl-td>

              <tbl-td
                name="league"
                :sort="true"
                @click.native="sort('league')"
                v-if="checkCol('league', tblSetting)"
              >
                league
              </tbl-td>

              <tbl-td
                name="schedule"
                :sort="true"
                @click.native="sort('play_date')"
                v-if="checkCol('schedule', tblSetting)"
              >
                schedule
              </tbl-td>

              <tbl-td
                name="home-team"
                :sort="true"
                @click.native="sort('home_team')"
                v-if="checkCol('home_team', tblSetting)"
              >
                home team
              </tbl-td>

              <tbl-td
                name="away-team"
                :sort="true"
                @click.native="sort('away_team')"
                v-if="checkCol('away_team', tblSetting)"
              >
                away team
              </tbl-td>

              <tbl-td
                name="matches_cnt"
                :sort="true"
                @click.native="sort('matches_cnt')"
                v-if="checkCol('matches_cnt', tblSetting)"
              >
                Match Games
              </tbl-td>

              <tbl-td
                name="users_cnt"
                :sort="true"
                @click.native="sort('users_cnt')"
                v-if="checkCol('users_cnt', tblSetting)"
              >
                User count
              </tbl-td>

              <tbl-td
                name="bet_amount"
                :sort="true"
                @click.native="sort('bet_amount')"
                v-if="checkCol('bet_amount', tblSetting)"
              >
                Total Bet
              </tbl-td>

              <tbl-td
                name="win_amount"
                :sort="true"
                @click.native="sort('win_amount')"
                v-if="checkCol('win_amount', tblSetting)"
              >
                Total Win
              </tbl-td>

              <tbl-td
                name="is-active"
                :sort="true"
                @click.native="sort('status')"
                v-if="checkCol('is_active', tblSetting)"
              >
                status
              </tbl-td>

              <tbl-td
                name="is-active"
                :sort="true"
                @click.native="sort('active')"
                v-if="checkCol('is_active', tblSetting)"
              >
                is active
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>

              <tbl-td name="actions"></tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(match, id) in matches"
              :key="match.id"
              :class="{'is-deleted': !match.active }"
              @click.native="view(match.id)"
            >
              <tbl-td class="checkbox" @click.native.stop>
                <checkbox>
                  <input
                    type="checkbox"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('no', tblSetting)"
                @click.native="sort('no')"
              >
                {{ generateNumber(id, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ match.created_at | date }}
              </tbl-td>

              <tbl-td
                class="game"
                @click.native="sort('game')"
                v-if="checkCol('game', tblSetting)"
              >
                <div
                  class="input-wrap"
                  v-if="match.shouldEdit"
                >
                  <select-list
                    :title="gameNameById(match.league) || 'GAME'"
                    :withReset="true"
                    v-model="match.league"
                  >
                    <select-option
                      v-for="game in games"
                      :value="game.id"
                      :key="game.id"
                      :name="game.name"
                    >
                      {{ game.name }}
                    </select-option>
                  </select-list>
                </div>
                <span v-else>
                  {{ match.league_meta.game }}
                </span>
              </tbl-td>

              <tbl-td
                class="league"
                v-if="checkCol('league', tblSetting)"
              >
                <div
                  class="input-wrap"
                  v-if="match.shouldEdit"
                >
                  <input
                    v-model="match.league_meta.name"
                    type="text"
                    @click.stop
                  />
                </div>
                <span v-else>
                  {{ match.league_meta.name }}
                </span>
              </tbl-td>

              <tbl-td
                class="schedule"
                v-if="checkCol('schedule', tblSetting)"
              >
                <date-time-picker
                  mode="schedule"
                  type="datetime"
                  placeholder="schedule"
                  v-model="match.play_date"
                  v-if="match.shouldEdit"
                  :range="false"
                  @click.native.stop
                >
                </date-time-picker>
                <span v-else>
                  {{ match.play_date | date }}
                </span>
              </tbl-td>

              <tbl-td
                class="home-team"
                v-if="checkCol('home_team', tblSetting)"
              >
                <div
                  class="input-wrap"
                  v-if="match.shouldEdit"
                >
                  <input
                    v-model="match.home_team_meta.name"
                    type="text"
                    @click.stop
                  />
                </div>
                <span v-else>
                  {{ match.home_team_meta.name }}
                </span>
              </tbl-td>

              <tbl-td
                class="away-team"
                v-if="checkCol('away_team', tblSetting)"
              >
                <div
                  class="input-wrap"
                  v-if="match.shouldEdit"
                >
                  <input
                    v-model="match.away_team_meta.name"
                    type="text"
                    @click.stop
                  />
                </div>
                <span v-else>
                  {{ match.away_team_meta.name }}
                </span>
              </tbl-td>

              <tbl-td
                class="match-games"
                v-if="checkCol('matches_cnt', tblSetting)"
              >
                <span>
                  {{ match.matches.cnt || 0 }}
                </span>
              </tbl-td>

               <tbl-td
                class="user-count"
                v-if="checkCol('users_cnt', tblSetting)"
              >
                <span>
                  {{ match.matches.ucnt || 0 }}
                </span>
              </tbl-td>

              <tbl-td
                class="bet_amount"
                v-if="checkCol('bet_amount', tblSetting)"
                @click.native.stop="openBets(match.id)"
              >
                <span>
                  {{ match.matches.bet_amount || 0 | FormatAmount }}
                </span>
              </tbl-td>

              <tbl-td
                class="win_amount"
                v-if="checkCol('win_amount', tblSetting)"
                @click.native.stop="openBets(match.id)"
              >
                <span>
                  {{ match.matches.win_amount || 0 | FormatAmount }}
                </span>
              </tbl-td>
              <tbl-td
                class="is-active"
                @click.native.stop
                v-if="checkCol('is_active', tblSetting)"
              >
                <select-list
                  v-model="match.status"
                  :title="match.status"
                >
                  <select-option
                    key="waiting"
                    name="waiting"
                    value="waiting"
                    @click.native="setSelected(match.status)"
                  >
                    waiting
                  </select-option>

                  <select-option
                    key="ongoing"
                    name="ongoing"
                    value="ongoing"
                    @click.native="setSelected(match.status)"
                  >
                    ongoing
                  </select-option>

                  <select-option
                    key="done"
                    name="done"
                    value="done"
                    @click.native="setSelected(match.status)"
                  >
                    done
                  </select-option>

                  <select-option
                    key="cancelled"
                    name="cancelled"
                    value="cancelled"
                    @click.native="setSelected(match.status)"
                  >
                    cancelled
                  </select-option>

                  <select-option
                    key="void"
                    name="void"
                    value="void"
                    @click.native="setSelected(match.status)"
                  >
                    void
                  </select-option>
                </select-list>
              </tbl-td>

              <tbl-td
                class="is-active"
                @click.native.stop
                v-if="checkCol('is_active', tblSetting)"
              >
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="show"
                  toggleB="hide"
                  @click.native.prevent="visibility(match)"
                >
                  <input
                    type="checkbox"
                    v-model="match.active"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ match.updated_at | date }}
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                --need data--
              </tbl-td>

              <tbl-td
                name="actions"
              >
                <button
                  class="btn--edit"
                  title="edit"
                  v-if="!match.shouldEdit"
                  @click.stop="triggerEditMatch(match)"
                >
                  <i class="ico--edit"></i>
                </button>

                <!-- <button
                  class="btn--modify"
                  title="save"
                  v-else
                  @click.stop="triggerEditMatch(match)"
                >
                  <i class="ico--save"></i>
                </button> -->

                <button
                  class="btn--delete"
                  title="save"
                  v-if="match.shouldEdit"
                  @click.stop="match.shouldEdit = false"
                >
                  <i class="ico--close"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create"
      title="modify/create game"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>game</span></div>
            <div class="form-data">
              <select-list
                :title="gameNameById(game_type_id) || 'GAME'"
                :withReset="true"
                v-model="game_type_id"
              >
                <select-option
                  v-for="game in games"
                  :value="game.id"
                  :key="game.id"
                  :name="game.name"
                >
                  {{ game.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>league</span></div>
            <div class="form-data">
              <select-list
                ref="leagueList"
                :title="tempLeague ? tempLeague.name : 'league'"
                :withReset="true"
                v-model="tempLeague"
              >
                <select-option
                  v-for="league in leagues"
                  :key="league.id"
                  :value="league"
                  :name="league.name"
                >
                  {{ league.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>schedule</span></div>
            <div class="form-data">
              <date-time-picker
                mode='mode'
                placeholder='schedule'
                v-model="editMatch.play_date"
              >
              </date-time-picker>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>home team</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchTeams"
                v-model="homeTeam"
                placeholder="Home Team"
              >
                <span slot="selected">{{ homeTeam ? homeTeam.name : '' }}</span>
                <suggestion
                  slot="suggestion"
                  :key="team.id"
                  v-for="team in teams"
                  :value="team"
                >
                  {{ team.name }}
                </suggestion>
              </input-suggestion>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>away team</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchTeams"
                v-model="awayTeam"
                placeholder="Away Team"
              >
                <div slot="selected">{{ awayTeam ? awayTeam.name : '' }}</div>
                <suggestion
                  slot="suggestion"
                  :key="team.id"
                  v-for="team in teams"
                  :value="team"
                >
                  {{ team.name }}
                </suggestion>
              </input-suggestion>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>game status</span></div>
            <div class="form-data">
              <checkbox
                type="toggle"
                class="toggle--inverted"
                :toggleA="editMatch.active ? 'active' : 'inactive'"
                :toggleB="editMatch.active ? 'active' : 'inactive'"
                @click.native.stop="editMatch.active = !editMatch.active"
              >
                <input
                  type="checkbox"
                  v-model="editMatch.active"
                />
              </checkbox>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="save()"
        >
          <i class="ico--save"></i>
          <span>save</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import FormatAmount from '@/assets/js/filters/FormatAmount'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import DateTimePicker from '@/components/base/DateTimePicker'
import Modal from '@/components/base/Modal'

import '@/components/base/input/InputSuggestion.js'
import '@/components/base/table/Table'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

export default {
  name: 'matches',

  filters: { FormatAmount },
  components: {
    Checkbox,
    Pagination,
    Search,
    CheckDataList,
    DateTimePicker,
    Modal
  },

  mixins: [
    swal,
    checkAll
  ],

  data () {
    return {
      matches: [],
      showCreate: false,
      showTblSettings: false,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      tblSetting: 'matches_list',

      selected: [],
      selectAll: false,

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      allCols: [
        {
          value: 'no',
          display: 'no'
        },
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'game',
          display: 'game'
        },
        {
          value: 'league',
          display: 'league'
        },
        {
          value: 'schedule',
          display: 'schedule'
        },
        {
          value: 'home_team',
          display: 'home team'
        },
        {
          value: 'away_team',
          display: 'away team'
        },
        {
          value: 'home_score',
          display: 'home score'
        },
        {
          value: 'away_score',
          display: 'away score'
        },
        {
          value: 'is_active',
          display: 'is active'
        },
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        },
        {
          value: 'matches_cnt',
          display: 'matches'
        },
        {
          value: 'users_cnt',
          display: 'users'
        },
        {
          value: 'bet_amount',
          display: 'total Bets'
        },
        {
          value: 'win_amount',
          display: 'total Win'
        }
      ],

      homeTeam: null,
      awayTeam: null,
      tempLeague: '',
      game_type_id: '',
      editMatch: {
        league: undefined,
        away_team: undefined,
        home_team: undefined,
        play_date: '',
        away_score: 0,
        home_score: 0,
        active: false
      },

      filterBy: [
        {
          value: 'game',
          display: 'game'
        },
        {
          value: 'league',
          display: 'league'
        },
        {
          value: 'home_team',
          display: 'Home Team'
        },
        {
          value: 'away_team',
          display: 'Away Team'
        }
      ]
    }
  },

  computed: {
    ...mapGetters('match', ['all', 'types', 'count']),
    ...mapGetters('game', { games: 'all' }),
    ...mapGetters('league', { leagues: 'all' }),
    ...mapGetters('team', ['teams']),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search(this.generate($router.query))
    },

    async game_type_id (id) {
      if (id !== this.editMatch.game_type_id) {
        this.$refs.leagueList.reset = true
      }

      console.log(id, 'sure  jd  nio?')
      await this.getLeagues({
        params: { rows: 1000, filter_by: 'game_type_id', q: id }
      })
      await this.getTeams({ rows: 50 })
    },

    tempLeague (league) {
      if (league) {
        this.editMatch.league = league.id
        this.editMatch.game_type_id = league.game_type_id
        this.game_type_id = league.game_type_id
      }
    }
  },

  async created () {
    this.selectedList = this.$route.params.status || 'all'
    let params = { status: this.selectedList, params: this.params }

    this.getCount(params)
    await this.get(params); await this.getGames({ params: { rows: 1000 } })
    await this.getLeagues({
      params: { rows: 1000 }
    })

    // == flags set
    this.isDataLoading = false
    this.showDataLoading = false
    if (!this.all.length) {
      this.isEmpty = true
    }

    this.setMatches()
  },

  methods: {
    ...mapActions('league', { getLeagues: 'get' }),
    ...mapActions('match', ['get', 'create', 'update', 'delete', 'getCount']),
    ...mapActions('game', { getGames: 'get' }),
    ...mapActions('team', { getTeams: 'get' }),

    triggerEditMatch (game) {
      this.editMatch = game
      this.showCreate = true

      this.homeTeam = this.editMatch.home_team_meta
      this.awayTeam = this.editMatch.away_team_meta
      this.tempLeague = this.editMatch.league_meta
    },

    updateSingle (e) {
      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, async () => {
        e.shouldEdit = false
      }, 'Save Match')
    },

    openBets (id) {
      window.open(
        `${process.env.VUE_APP_URL}/bet-history/matches/?filter_by=match_id&q=${id}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    },

    setMatches () {
      let matches = JSON.parse(JSON.stringify(this.all))
      let extra = { shouldEdit: false }
      for (var i = 0; i < matches.length; i++) {
        matches[i].shouldEdit = false
      }

      this.matches = matches
    },

    change (val) {
      this.$router.push({ params: { status: val } })
    },

    gameNameById (val) {
      let temp = this.games.find((row) => { return row.id === val })
      return temp ? temp.name : ''
    },

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      let params = { status: this.selectedList, params: this.params }

      await this.getCount(params)
      await this.get(params)

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.all.length) {
        this.isEmpty = true
      }

      this.setMatches()
    },

    async visibility (params) {
      let success = async () => {
        params.active = !params.active
        await this.update(params)
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Show/Hide Match')
    },

    clear () {
      this.editMatch = {
        league: undefined,
        away_team: undefined,
        home_team: undefined,
        play_date: '',
        away_score: 0,
        home_score: 0,
        active: false
      }
    },

    async save () {
      let success = async () => {
        this.editMatch.home_team = this.homeTeam.id
        this.editMatch.away_team = this.awayTeam.id

        if (this.editMatch.id) {
          await this.update(this.editMatch)
        } else {
          await this.create(this.editMatch)
        }

        this.clear()

        let params = { status: this.selectedList, params: this.params }
        await this.getCount(params); await this.get(params)

        this.showCreate = false
      }

      this.$alert('prompt', 'Are you sure you want to save/create game?', {}, { success }, 'Save/Create Match')
    },

    updateSingle (e) {
      let success = async () => {
        e.shouldEdit = false
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Save Match')
    },

    async searchTeams (q) {
      console.log(this.editMatch.game_type_id, 'wakjhrawhdashdahjshd')
      let params = { rows: 50, gameTypeId: this.editMatch.game_type_id }

      if (q) {
        params.filter_by = 'name'
        params.q = q
      }

      await this.getTeams(params)
    },

    view (id) {
      if (this.checkPermission) {
        this.$router.push(`/match/${id}`)
      }
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.trigger()
    },

    setSelected (data) {
    }
  }
}
</script>
